import { ImagesService } from '@/app/modules/images/core/service';
import {
  Component,
  Input,
  OnChanges,
  OnDestroy,
  SimpleChanges,
} from '@angular/core';
import { NzAvatarModule } from 'ng-zorro-antd/avatar';
import { NzShapeSCType, NzSizeLDSType } from 'ng-zorro-antd/core/types';
import { NzSpinModule } from 'ng-zorro-antd/spin';
import { BehaviorSubject, finalize } from 'rxjs';
import { LoaderService } from '../../services/loader/loader.service';
import { AsyncPipe, NgClass, NgStyle, CommonModule } from '@angular/common';

@Component({
  selector: 'az_avatar',
  templateUrl: './avatar.component.html',
  styleUrls: ['./avatar.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    NzAvatarModule,
    NzSpinModule,
    AsyncPipe,
    NgStyle,
    NgClass,
  ],
})
export class AvatarComponent implements OnChanges, OnDestroy {
  readonly defaultImage = './assets/images/logo-back-white.svg';

  readonly defaultSize = 'small';

  readonly defaultShape = 'circle';

  readonly defaultColor = '#c0142c';

  readonly defaultBackground = '#fde3cf';

  private previousImage?: string;

  @Input() src?: string;

  @Input() fullWidth?: boolean = false;

  @Input() fullHeight?: boolean = false;

  @Input() centerImage?: boolean = false;

  @Input() maxHeight?: string;

  @Input() size?: NzSizeLDSType | number;

  @Input() shape?: NzShapeSCType;

  @Input() text?: string;

  @Input() icon?: string;

  @Input() color?: string;

  @Input() background?: string;

  @Input() useDefault?: boolean = false;

  isLoading = new BehaviorSubject<boolean>(false);

  private imageReq?: any;

  constructor(
    private imageService: ImagesService,
    private loaderService: LoaderService
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (!changes['src']) return;

    if (changes['src'].currentValue == this.previousImage) return;

    this.load();
  }

  ngOnDestroy(): void {
    this.isLoading.next(false);
    this.isLoading.complete();
    this.isLoading.unsubscribe();
  }

  private load() {
    this.previousImage = this.src;

    const cancelRequest = () => {
      this.imageReq?.unsubscribe();
      delete this.imageReq;
    };

    if (this.imageReq) {
      cancelRequest();
    }

    this.imageReq = this.loaderService
      .executeWithLoader(this.imageService.photo(this.src), this.isLoading)
      .pipe(
        finalize(() => {
          cancelRequest();
        })
      )
      .subscribe({
        next: (image) => {
          this.src = image;
        },
        error: () => {
          if (this.useDefault) delete this.src;
        },
      });
  }
}
